export default "__VITE_ASSET__DLmbFRIk__"